import * as Yup from 'yup'
import { ErrorMessage, Form, Formik } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Calendar from '../../../components/calendar/Calendar'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { addIdKeyToObject, convertDateFormatCalendar, exportKitDistributionReport, generateDropdownOptions } from '../../../utility/genricFunction'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './inquiryReport.scss'
import {
  getCourseFromBranch,
  getInquiryReport,
} from '../../../store/builders/reports/reports.builder'
import dayjs from 'dayjs'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

const InquiryReport = () => {
  const dispatch = useDispatch()
  const [showTable, setShowTable] = useState(false)
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const { courseByBranchData: courses, inquiryReport, loading , pageDropDownLoading } = useSelector((state) => state?.reports)
  
  const courseOption = useMemo(() => generateDropdownOptions(courses, 'courseName', 'courseId'), [courses])
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
  const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)
  
  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == "branch" ? branchId : '',
    course: '',
  })

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
});

  useEffect(()=>{
    if(userRole == "branch"){
      dispatch(getCourseFromBranch(branchId))
    }
  })

  const breadCrumbsArr = [
    {
      title: 'Inquiry Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Inquiry Report',
      link: ROUTES_PATH.INQUIRY_REPORT,
    },
  ]

  const columns = [
    {
      field: 'id',
      header: '#',
      filter: false,
    },
    {
      field: 'inquiry_type',
      header: 'Inquiry Type',
      filter: false,
      style: { minWidth: '8rem' },
    },
    {
      field: 'enroll_alive_count',
      header: 'Alive',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'enroll_dead_count',
      header: 'Dead',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'enroll_total_count',
      header: 'Total',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
  ]

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required('From Date is required').typeError('Invalid Date'),
    toDate: Yup.date()
      .required('To Date is required')
      .typeError('Invalid Date')
      .min(Yup.ref('fromDate'), 'To Date cannot be before From Date'),
    branch: Yup.string().required('Branch is required'),
    course: Yup.string().required('Course is required'),
  })

  const handleBranchDropDownChange = (value, setFieldValue) => {
    setFieldValue('branch', value)
    dispatch(getCourseFromBranch(value))
  }

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> && <div className='inquiry-report-wrapper'>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(value) => {
          setShowTable(true)
          const data = {
            startDate: dayjs(value.fromDate).format('YYYY-MM-DD'),
            endDate: dayjs(value.toDate).format('YYYY-MM-DD'),
            branchId: value.branch,
            courseId: value.course,
          }
          dispatch(getInquiryReport(data))
        }}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='time-table-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='time-table-report-main-div'>
              <div className='time-table-report-input-fields'>
                <Calendar
                  label='From Date'
                  name='fromDate'
                  required={true}
                  width={'25%'}
                  onChange={(values) => {
                    setFieldValue('fromDate', convertDateFormatCalendar(values))
                  }}
                />
                <Calendar
                  label='To Date'
                  name='toDate'
                  required={true}
                  width={'25%'}
                  value={values.toDate}
                  onChange={(values) => {
                    setFieldValue('toDate', convertDateFormatCalendar(values))
                  }}
                />
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    options={branchOption}
                    selectedValue={values.branch}
                    disabled={userRole == "branch"}
                    onChange={(e) => {
                      handleBranchDropDownChange(e.target.value, setFieldValue)
                    }}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
                <div className='time-table-report-dropdown'>
                  <label htmlFor=''>
                    Course<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'course'}
                    placeholder={'Select Course'}
                    options={courseOption}
                    selectedValue={values.course}
                    onChange={handleChange}
                  />
                  <ErrorMessage name='course' component='div' className='error-msg' />
                </div>
              </div>

              <div className='submit-btn-wrapper'>
                <Button type='submit' customClassName={'tt-report-btn-submit'}>
                  Submit
                </Button>
              </div>
            </div>
            {showTable && (
              <div className='inquiry-report-table-div'>
                <div className='export-option-wrapper'>
                  <div className='pdf-excel-export'>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={() =>
                        exportKitDistributionReport(addIdKeyToObject(inquiryReport.inquiry), columns)
                      }
                    >
                      <SimCardDownloadIcon/>
                    </Button>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={handleDownloadPfd}
                    >
                      <PrintIcon/>
                    </Button>
                  </div>
                </div>


                <div className='printable-component' ref={printRef}>
                <ReportDataTable columns={columns} value={addIdKeyToObject(inquiryReport.inquiry)} />
                </div>
                
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>}
    </>
  )
}

export default InquiryReport
